(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-seo-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('n7-seo-text')) {
    class N7SeoText extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('.n7-seo-text__body');
        this.toggle = this.querySelector('.n7-seo-text__toggle');
        if (!this.body || !this.toggle) return;

        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.expanded = false;

        this.onToggle = () => {
          this.expanded = !this.expanded;
          this.update();
          if (!this.expanded) this.scrollIntoView({ block: 'nearest' });
        };
        // Un lien atteint au clavier dans la partie repliée ne doit pas rester caché
        this.onFocusIn = (event) => {
          if (this.hasAttribute('data-collapsed') && this.body.contains(event.target)) {
            this.expanded = true;
            this.update();
          }
        };
        this.onChange = () => this.update();

        this.toggle.addEventListener('click', this.onToggle);
        this.body.addEventListener('focusin', this.onFocusIn);
        this.mobileQuery.addEventListener('change', this.onChange);
        this.update();
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.onToggle);
        this.body?.removeEventListener('focusin', this.onFocusIn);
        this.mobileQuery?.removeEventListener('change', this.onChange);
      }

      update() {
        const isMobile = this.mobileQuery.matches;
        const collapsible = isMobile
          ? this.classList.contains('n7-seo-text--collapse-mobile')
          : this.classList.contains('n7-seo-text--collapse-desktop');
        const limit = parseFloat(getComputedStyle(this).getPropertyValue('--n7-seo-collapsed-height')) || 220;
        // Pas de bouton si le texte tient déjà (à 40 px près) dans la hauteur repliée
        const needed = collapsible && this.body.scrollHeight > limit + 40;

        this.toggle.hidden = !needed;
        this.toggle.setAttribute('aria-expanded', String(this.expanded));
        this.toggleAttribute('data-collapsed', needed && !this.expanded);
      }
    }

    customElements.define('n7-seo-text', N7SeoText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
